module.exports = __webpack_public_path__ + "static/img/10.faac38c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/zh/10.png
// module id = 83U9
// module chunks = 0